/* global $, game */

$.ready(function() {
	/* global spinReady, spinDone, scatterCan */

	var spindle = game.spindle = $.div('spindle').appendTo(game.container);
	spindle.reels = [];

	var frame = game.frame = $.div('frame').appendTo(game.container);
	frame.reels = [];

	game.on('scale', function() {
		for (var reel = 0; reel < frame.reels.length; reel++) {
			for (var row = 0; row < frame.reels[reel].symbols.length; row++) {
				var symbol = frame.reels[reel].symbols[row];

				symbol.css('width', null);
				symbol.css('width', symbol.el.offsetWidth);
			}
		}
	});

	spindle.spin = function() {
		this.trigger('spin');
		for (var reel in spindle.reels) {
			spindle.reels[reel].addClass('start');
			spindle.reels[reel].update('first');
		}
	};

	spindle.clear = function() {
		for (var reel in spindle.reels) {
			spindle.reels[reel].removeClass('start loop end');
		}
	};

	spindle.on('animationend', 'reel', function() {
		var index = this.index();

		if (this.hasClass('start')) {
			if (spindle.stop === -1) {
				this.addClass('end');
			}

			else {
				this.addClass('loop');
			}

			this.removeClass('start');

			/* eslint-disable no-bitwise */
			spindle.ready |= (1 << index);

			if (spindle.ready === (1 << spindle.reels.length) - 1) {
				spinReady();
			}
			/* eslint-enable no-bitwise */
		}

		else if (this.hasClass('end')) {
			game.anticipation.hide(index);

			game.trigger('reel_stop', { index: index });

			if (spindle.stop >= 0) {
				spindle.stop++;
			}

			this.removeClass('end');

			/* eslint-disable no-bitwise */
			spindle.done |= (1 << index);

			if (spindle.done === (1 << spindle.reels.length) - 1) {
				spinDone();
			}
			/* eslint-enable no-bitwise */
		}
	});

	spindle.on('animationiteration', 'reel', function() {
		if (this.hasClass('loop')) {
			var index = this.index();

			if (spindle.stop === index) {
				/* jshint -W004 */
				for (var s in game.specials) {
					/* jshint +W004 */

					if (game.specials[s].anticipate && game.specials[s].count >= game.specials[s].min && scatterCan(s)) {
						if (!game.specials[s].count_spins) {
							game.specials[s].count_spins = 0;

							game.sounds.play([ 'anticipate', s ]);
							game.anticipation.show(index);
						}

						game.specials[s].count_spins++;

						if (game.specials[s].count_spins < (game.specials[s].max_spins || 7)) {
							return;
						}

						game.specials[s].count_spins = 0;
						break;
					}
				}
			}

			if (spindle.stop === -1 || spindle.stop === index) {
				this.addClass('end');
				this.removeClass('loop');

				game.sounds.play([ 'reels' ], 0.25);
				game.sounds.play([ 'reel', this.index() ], 0.25);

				/* jshint -W004 */
				for (var s in game.specials) {
					/* jshint +W004 */
					if (game.specials[s].count === null) {
						continue;
					}

					if (!game.specials[s].reels || game.specials[s].reels.indexOf(index) !== -1) {
						if (game.last.matrix[index].indexOf(+s) !== -1 || (game.specials[s].alternative && game.last.matrix[index].indexOf(game.specials[s].alternative) !== -1)) {
							if (scatterCan(s)) {
								game.sounds.play([ 'drop', s, game.specials[s].count ], 0.25);
							}

							if (game.specials[s].ignoreSequential === true) {
								game.sounds.play([ 'drop', s, game.specials[s].count ], 0.25);
							}
							
							if (!game.specials[s].multiScatterReels) {
								game.specials[s].count++;
							}
							
							else {
								for (let symbol in game.last.matrix[index]) {
									if (game.last.matrix[index][symbol] === +s) {
										game.specials[s].count++;
									}
								}
							}
						}

						else if (game.pays.scatters && game.pays.scatters.sequential && game.specials[s].ignoreSequential !== true) {
							game.specials[s].count = null;
						}
					}
				}
			}

			else {
				spindle.reels[index].update();
			}
		}
	});

	game.on('ui', function(config) {
		config = config.detail;

		/* Clear UI */
		{
			spindle.empty();
			spindle.container = $.div().addClass('reels').appendTo(spindle);
			spindle.reels = [];

			frame.empty();
			frame.container = $.div().addClass('reels').appendTo(frame);
			frame.reels = [];
		}

		/* Build UI */
		{
			var reelUpdate = function(rows, flag) {
				if (flag === 'reset') {
					this.real.index = Math.floor(Math.random() * this.real.length);
				}

				else {
					this.real.index = (this.real.index + 15) % this.real.length;
				}

				for (var row = 0; row < rows; row++) {
					if (this.window.symbols[row].el.classList.length === 1) {
						this.window.symbols[row].attr('class', 'symbol symbol-' + this.real[row]);
					}
				}

				var i = 0;

				for (var row = 0; row < rows; row++) {
					var pos = (this.real.index + row) % this.real.length;
					this.symbols[i++].attr('class', 'symbol symbol-' + this.real[pos]);
				}

				for (var row = 0; row < rows * 2; row++) {
					var pos = (this.real.index + row) % this.real.length;
					this.symbols[i++].attr('class', 'symbol symbol-' + this.real[pos]);
				}

				setTimeout((function() {
					for (row = 0; row < rows; row++) {
						var pos = (this.real.index + row) % this.real.length;
						this.symbols[i++].attr('class', 'symbol symbol-' + this.real[pos]);
					}
				}).bind(this), flag === 'first' ? 0 : 400 / 2);
			};

			for (var reel = 0; reel < config.reels; reel++) {
				var rows = config.rows;
				if (rows.constructor === Array) {
					rows = rows[reel];
				}

				frame.reels[reel] = $.div().addClass('reel reel-' + reel).appendTo(frame.container);
				frame.reels[reel].symbols = [];

				spindle.reels[reel] = $.div().addClass('reel reel-' + reel).appendTo(spindle.container);
				spindle.reels[reel].symbols = [];
				spindle.reels[reel].window = $.div().addClass('window');
				spindle.reels[reel].window.symbols = [];
				spindle.reels[reel].real = [];
				spindle.reels[reel].update = reelUpdate.bind(spindle.reels[reel], rows);

				for (var row = 0; row < rows; row++) {
					spindle.reels[reel].window.symbols[row] = $.div().addClass('symbol').appendTo(spindle.reels[reel].window);
					frame.reels[reel].symbols[row] = $.div().addClass('symbol').appendTo(frame.reels[reel]);
					$.div().appendTo(frame.reels[reel].symbols[row]);

					// var symbol = frame.reels[reel].symbols[row];
					// symbol.css('width', symbol.el.offsetWidth);
				}

				var i = 0;

				for (var row = 0; row < rows; row++) {
					spindle.reels[reel].symbols[i++] = $.div().addClass('symbol').appendTo(spindle.reels[reel]);
				}

				spindle.reels[reel].window.appendTo(spindle.reels[reel]);

				for (var row = 0; row < rows * 2; row++) {
					spindle.reels[reel].symbols[i++] = $.div().addClass('symbol').appendTo(spindle.reels[reel]);
				}

				for (var row = 0; row < rows; row++) {
					spindle.reels[reel].symbols[i++] = $.div().addClass('symbol').appendTo(spindle.reels[reel]);
				}
			}
		}
	});

	game.controller.socket.on('reels', function(reels) {
		game.trigger('reel_init', { reels: reels });

		for (var reel = 0; reel < spindle.reels.length; reel++) {
			spindle.reels[reel].real = reels[reel];
			spindle.reels[reel].update('reset');
		}
	});
});



/** WEBPACK FOOTER **
 ** /Users/kevinduarte/SG/roc2/plugins/slot/public-src/common/js/container-reels.js
 **/